import {
    withInterstitial,
} from 'wanderu-component-page-loader';

const RESEARCH_PAGES = [
    'schedule-a-call',
];

const ResearchPage = withInterstitial(import('./pages/Research'));

export default [
    {
        component: ResearchPage,
        key: 'research-pages',
        path: '/research/schedule-a-call/',
    },
];
